import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './services/frontdoor/login.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'MichaelCKerr';
  isAuthenticated = false;
  constructor(private loginService: LoginService, private router: Router) { }

  ngOnInit(): void {
    // IMPORTANT: Subscribe to checkAuth so we actually know if user is authenticated
    this.loginService.checkAuth().subscribe(isAuth => {
      this.isAuthenticated = isAuth;
      //console.log('isAuth', isAuth);
    });
      //would need setauthstate in auth service
     // this.authService.checkAuth().subscribe(isAuth => this.authService.setAuthState(isAuth));
  }
  onLogout() {
    // Call the logout endpoint, then reset isAuthenticated
    this.loginService.logout().subscribe(() => {
      this.isAuthenticated = false;
      // Optionally redirect to login or home
      this.router.navigate(['/login']);
    });
  }
}
